import { Observable } from "../../utilities/index.js";
export function fromPromise(promise) {
    return new Observable(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
//# sourceMappingURL=fromPromise.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/utils/fromPromise.js
// module id = ./node_modules/@apollo/client/link/utils/fromPromise.js
// module chunks = 54 55